var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFrontParkingSensor24 = function SvgFrontParkingSensor24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2 6.5h1.597c.716 0 1.403.304 1.91.845.507.541.791 1.275.791 2.04v6.692c0 .318-.058.633-.172.927a2.442 2.442 0 0 1-.492.786 2.27 2.27 0 0 1-.737.526c-.275.121-.57.184-.868.184h-2.46c-.299 0-.594-.063-.87-.184a2.265 2.265 0 0 1-.736-.526 2.44 2.44 0 0 1-.492-.786 2.567 2.567 0 0 1-.172-.927V9.385c0-.379.07-.754.205-1.104a2.91 2.91 0 0 1 .586-.936c.25-.268.549-.48.877-.625a2.55 2.55 0 0 1 1.034-.22v0Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.104 9.5h1.789c.69 0 1.354.299 1.842.83.489.53.764 1.251.764 2.003v2.392a.81.81 0 0 1-.21.548.685.685 0 0 1-.503.227H9.21a.685.685 0 0 1-.504-.227.81.81 0 0 1-.208-.548v-2.392c0-.752.274-1.472.763-2.003a2.505 2.505 0 0 1 1.842-.83v0Zm-2.605.864h-2m11 0h-2",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 11.039v6.435c0 1.2-.486 2.352-1.35 3.2A4.652 4.652 0 0 1 16.391 22H7.61a4.652 4.652 0 0 1-3.26-1.326 4.488 4.488 0 0 1-1.349-3.2V7.526c0-1.2.486-2.352 1.35-3.2A4.652 4.652 0 0 1 7.609 3H13m4-2h1.369c1.228 0 2.406.503 3.274 1.397A4.845 4.845 0 0 1 23 5.771V7m-6-3h.684c.611 0 1.198.25 1.632.695A2.44 2.44 0 0 1 20 6.381V7",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgFrontParkingSensor24;